import { render, staticRenderFns } from "./BannerImageSection.vue?vue&type=template&id=c5cffec8"
import script from "./BannerImageSection.vue?vue&type=script&lang=ts"
export * from "./BannerImageSection.vue?vue&type=script&lang=ts"
import style0 from "./BannerImageSection.vue?vue&type=style&index=0&id=c5cffec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports